<template>
  <div class="page-admin">
    <!-- New User Modal -->
    <div v-if="showNewUserOverlay" class="overlay">
      <div class="form-container" @click.stop>
        <button class="btn-close" @click="closeOverlay">
          <i class="fas fa-times"></i>
        </button>

        <form @submit.prevent="submitForm" autocomplete="off">
          <!--
          <div class="row">
            <div class="col col-12">
              <div class="container">
                <h2>Create New User</h2>
              </div>
            </div>
          </div>
          -->
          

          <!-- Hidden input to confuse autofill -->
          <input type="text" style="display: none" autocomplete="off" />
          <input
            type="password"
            style="display: none"
            autocomplete="new-password"
          />

          <!-- Section 1: Account Information -->
          <div class="form-section">
            <div class="section-container">
              <h2 class="section-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
</svg>

                New Account Information</h2>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-12 col-lg-6">
                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Username must be unique"
                    >Username:</label>
                    <input
                      type="text"
                      class="form-control tooltip-label"
                      v-model="form.userName"
                      required
                      placeholder="Choose a unique username"
                    />
                  </div>

                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Please use this secure password">Password:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.password"
                      required
                      placeholder="Enter a secure password"
                    />
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-12 col-lg-6">
                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Email must be unique">Email:</label>
                    <input
                      type="email"
                      class="form-control"
                      v-model="form.email"
                      required
                      placeholder="Choose a unique email address"
                    />
                  </div>

                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Please use this secure password">Confirm Password:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.confirmPassword"
                      required
                      placeholder="Confirm password"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Section 2: General Information -->
          <div class="form-section">
            <div class="section-container" style="margin-top: 30px;">
              <h2 class="section-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" />
  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
</svg>

                General Information</h2>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-12 col-lg-6">
                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Enter the user's first name">First Name:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.firstName"
                      required
                      placeholder="Enter first name"
                    />
                  </div>

                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Enter the user's last name">Last Name:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.lastName"
                      required
                      placeholder="Enter last name"
                    />
                  </div>

                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Enter a phone number for the user">Phone Number:</label>
                    <input
                      type="tel"
                      class="form-control"
                      v-model="form.phoneNumber"
                      required
                      placeholder="Enter phone number"
                    />
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-12 col-lg-6">
                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Multiple companies for external users are available in the edit window after user creation">Company: </label>
                    <select
                      class="form-control"
                      v-model="form.company"
                      required
                    >
                      <option
                        :value="null"
                        selected
                        class="all-contractors"
                        id="firstSelector"
                        style="text-transform: capitalize !important"
                      >
                        Area Contractor
                      </option>
                      <option
                        v-for="ac in acs"
                        :key="ac.acid"
                        :value="ac.acid"
                        id="text"
                      >
                        {{ " " + ac.acName + " (" + ac.acid + ")" }}
                      </option>
                    </select>

                    <!--
                            <input type="text" class="form-control" v-model="form.company" value="ADVANCED ORGANIZATION" required>
                            -->
                  </div>

                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="If not a sales rep, the Rep ID must be 0. No hyphens are allowed in the Rep ID">Rep ID:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="repIdInput"
                      value="0"
                      required
                      @keypress="onlyNumbers"
                    />
                  </div>

                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Choose a department for the user"> Department: </label>
                    <select
                      class="form-control"
                      v-model="form.department"
                      required
                    >
                      <option value="">Select department</option>
                      <option value="EN">Engineering</option>
                      <option value="EA">Engineering Admin</option>
                      <option value="SA">Sales</option>
                      <option value="OP">Operations</option>
                      <option value="NR">North Receiving</option>
                      <option value="EL">Electrical</option>
                      <option value="MC">Material Coordinators</option>
                      <option value="HR">Human Resources</option>
                      <option value="IS">Information Systems</option>
                      <option value="MK">Marketing</option>
                      <option value="SM">Service Managers</option>
                      <option value="SS">Serivce Support</option>
                      <option value="AC">AC Support</option>
                      <option value="AS">AC User</option>
                      <option value="AD">Administrator</option>
                      <option value="FQ">Field Quality</option>
                      <option value="FI">Finance</option>
                      <option value="GS">GSA</option>
                      <option value="JP">Joint Projects</option>
                      <option value="OE">Order Entry</option>
                      <option value="PL">Planning</option>
                      <option value="AP">AC Principal</option>
                      <option value="PC">Production Control</option>
                      <option value="PU">Purchasing</option>
                      <option value="AU">AC Sales</option>
                      <option value="SV">Service</option>
                      <option value="SH">Shipping</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Section 3: Permissions -->
          <div class="form-section">
            <div class="section-container" style="margin-top: 30px;">
              <h2 class="section-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" />
  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
</svg>

                Permissions</h2>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-12 col-lg-6">
                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="User level options vary by selection"> User Type: </label>
                    <select
                      class="form-control"
                      v-model="form.userType"
                      required
                    >
                      <option value="">Select user type</option>
                      <option value="7808307F-10F4-4644-8674-70C4BB4C8BDD">
                        SSC Employee(Internal)
                      </option>
                      <option value="4666CBD3-CD25-488B-B508-DCAB6D358372">
                        AC(External)
                      </option>
                    </select>
                  </div>
                  

                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Hover the role for a description."> User Level: </label>
                    <select
                      v-if="
                        form.userType == '7808307F-10F4-4644-8674-70C4BB4C8BDD'
                      "
                      class="form-control"
                      v-model="form.userLevel"
                      required
                    >
                      <option value="" selected="selected">
                        Select user level
                      </option>
                      <option value="F9FDA66E-262B-408D-8DEC-7E3F02346588"
                      title="This is the standard role that most plant 1 employees have">
                        SSC Employee
                      </option>
                      <option value="40F1E2BA-1C81-4E8D-9512-A95C2028A1D5"
                      title="This is the same as SSC Empoyee. No elevated permissions">
                        SSC Management
                      </option>
                      <option value="9F2C80F0-A4B2-435A-BFAA-C56088BA71A5"
                      title="This is the standard role that most plant 2 employees have"
                      >
                        SSC Plant 2 Employee
                      </option>
                      <option value="B01B1609-92AC-48F3-A1FE-51785448F8C2"
                      title="This is the same as SSC Empoyee. No elevated permissions">
                        SSC RBM
                      </option>
                      <option value="F3C565C9-C65B-4CC9-868B-B0EF74C837F3"
                      title="This is only used if the user is managing user accounts">
                        Administrator
                      </option>
                    </select>

                    <select
                      v-else
                      class="form-control"
                      v-model="form.userLevel"
                      required
                    >
                      <option value="" selected="selected">
                        Select user level
                      </option>
                      <option 
                      value="A9714B0B-6A5C-4524-9A0E-0E6F0D425DF4"
                      title="This role has full company access">
                        AC Principal
                      </option>
                      <option value="D6C4AA1F-22B9-47CF-8386-7FF3E280717A"
                      title="This role will see only their own orders">
                        AC Salesperson
                      </option>
                      <option value="B9AD84BA-7656-447E-8678-2CA8241AF8A6"
                      title="This role is for sales managers. They will see all orders at the company.">
                        AC Admin Assistant
                      </option>
                      <option value="9F173158-5856-4F2E-9B25-BDB7514E060D"
                      title="This role will see all orders at the company.">
                        AC Marketing
                      </option>
                      <option value="F2BA98B3-E5A4-4331-9C6B-DAD131146346"
                      title="This role will see all orders at the company.">
                        AC Installer
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-12 col-lg-6">
                  <div v-if="form.userType == '4666CBD3-CD25-488B-B508-DCAB6D358372'" class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="This only applies to external users. An SSC employee does not need these.">External Privileges: Not Used for SSC Employees</label
                    >
                    <div>
                      <!--
                               <div class="checkbox-item">
                                    <input type="checkbox" v-model="form.privileges.supportRep" id="supportRep">
                                    <label for="supportRep">Support Rep</label>
                                </div>
                                <div class="checkbox-item">
                                    <input type="checkbox" v-model="form.privileges.announcementAdmin" id="announcementAdmin">
                                    <label for="announcementAdmin">Announcement Admin</label>
                                </div>
                                 <div class="checkbox-item">
                                    <input type="checkbox" v-model="form.privileges.blogAuthor" id="blogAuthor">
                                    <label for="blogAuthor">Blog Author</label>
                                </div>
                                 <div class="checkbox-item">
                                    <input type="checkbox" v-model="form.privileges.onComments" id="onComments">
                                    <label for="onComments">On Comments</label>
                                </div>
                                 <div class="checkbox-item">
                                    <input type="checkbox" v-model="form.privileges.widenAdmin" id="widenAdmin">
                                    <label for="widenAdmin">Widen Admin</label>
                                </div>
                              -->

                      <div
                        class="checkbox-item"
                        style="
                          display: flex;
                          align-items: center;
                          margin-bottom: 10px;
                        "
                      >
                        <input
                          type="checkbox"
                          v-model="form.privileges.cashManagement"
                          id="cashManagement"
                          true-value="5D26C210-77BE-41FE-A54E-8599F324A3CF"
                          class="custom-checkbox"
                        
                        />
                        <label for="cashManagement" 
                       
                        style="margin-bottom: 0"
                        
                          >Cash Management (Principal approval required)</label
                        >
                      </div>

                      <div
                        class="checkbox-item"
                        style="
                          display: flex;
                          align-items: center;
                          margin-bottom: 10px;
                        "
                      >
                        <input
                          type="checkbox"
                          v-model="form.privileges.expeditedOrders"
                          id="expeditedOrders"
                          true-value="355F9223-FAC7-4F66-BE31-396C2ACFC0EC"
                          class="custom-checkbox"
                        />
                        <label for="expeditedOrders" style="margin-bottom: 0"
                          >Expedited Orders</label
                        >
                      </div>
                      <div
                        class="checkbox-item"
                        style="
                          display: flex;
                          align-items: center;
                          margin-bottom: 10px;
                        "
                      >
                        <input
                          type="checkbox"
                          v-model="form.privileges.gsa"
                          id="gsa"
                          true-value="42DB7179-4AD2-42EF-83FC-D4E3AA053F00"
                          class="custom-checkbox"
                        />
                        <label for="gsa" style="margin-bottom: 0">GSA</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-actions">
            <button
              type="button"
              class="btn btn-secondary"
              @click="closeOverlay"
              style="padding: 5px 10px"
            >
              Cancel
            </button>
            <button type="submit" class="btn list-btn">Create Account</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Edit User Modal -->
    <div v-if="showEditUserOverlay" class="overlay" @click="closeOverlay">
      <div class="form-container" @click.stop>
        <button class="btn-close" @click="closeOverlay">
          <i class="fas fa-times"></i>
        </button>

        <form @submit.prevent="submitEditForm" autocomplete="off">
          
          
          
          <div class="row">
            <!--
            <div class="col col-6">
              <div class="container">
                <h2>Edit User</h2>
              </div>
            </div>
            -->
            <div class="col col-6" style="display: flex; align-items: center">
              <!--
              
              -->
              <div>
               
              </div>
            </div>
          </div>

          <!-- Hidden input to confuse autofill -->
          <input type="text" style="display: none" autocomplete="off" />
          <input
            type="password"
            style="display: none"
            autocomplete="new-password"
          />

          <!-- Section 1: Account Information -->
          <div class="form-section">
            <div class="section-container">
              <h2 class="section-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
</svg>
                Edit Account Information</h2>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-12 col-lg-6">
                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Username must be unique">Username:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="UserToEdit.userName"
                      required
                    />
                  </div>
                  <!--
   <div class="form-group">
                    <label class="required">Password:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.password"
                      required
                    />
                  </div>

                  <div class="form-group">
                    <label class="required">Confirm Password:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.confirmPassword"
                      required
                    />
                  </div>                
-->
                </div>
                <div class="col-xs-12 col-sm-12 col-12 col-lg-6">

                  <label
                  class="required"
                        >Account Status:</label
                      >
                  <div style="display: flex; margin-top: 3px;">
                  <div class="form-group" style="margin-bottom: 0">
                    <div
                      class="radios"
                      
                    >
                      
                      <div class="control-group" style="margin-top: 0">
                        <label
                          class="control control--radio"
                          style="margin-bottom: 0"
                        >
                          <span style="color: #575757 !important">Activated</span>
                          <input
                            type="radio"
                            name="radio"
                            checked="checked"
                            v-model="UserToEdit.active"
                            value="true"
                          />
                          <div class="control__indicator"></div>
                        </label>
                        <label
                          class="control control--radio"
                          style="margin-bottom: 0"
                        >
                          <span style="color: #575757 !important"
                            >Deactivated</span
                          >
                          <input
                            type="radio"
                            name="radio"
                            v-model="UserToEdit.active"
                            value="false"
                          />
                          <div class="control__indicator"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <!--
                
                -->
                 

                  <!--
   <div class="form-group">
                    <label class="required"> Security Question: </label>
                    <select
                      class="form-control"
                      v-model="form.securityQuestion"
                      required
                    >
                      <option value="">Select a security question</option>
                      <option value="mother-maiden-name">
                        What is your mother's maiden name?
                      </option>
                      <option value="first-pet">
                        What was your first pet's name?
                      </option>
                      <option value="childhood-street">
                        What street did you grow up on?
                      </option>
                      <option value="favorite-teacher">
                        Who was your favorite teacher?
                      </option>
                      <option value="What is your username?">What is your username?</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label class="required">Security Answer:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.securityAnswer"
                      required
                    />
                  </div>                
-->
                </div>
              </div>
            </div>
          </div>

          <!-- Section 2: General Information -->
          <div class="form-section">
            <div class="section-container" style="margin-top: 30px;">
              <h2 class="section-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" />
  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
</svg>
                General Information</h2>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-12 col-lg-6">
                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Enter the user's first name">First Name:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="UserToEdit.firstName"
                      required
                    />
                  </div>

                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Enter the user's last name">Last Name:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="UserToEdit.lastName"
                      required
                    />
                  </div>

                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Enter a phone number for the user">Phone Number:</label>
                    <input
                      type="tel"
                      class="form-control"
                      v-model="UserToEdit.phoneNumber"
                      required
                    />
                  </div>

                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Email must be unique">Email:</label>
                    <input
                      type="email"
                      class="form-control"
                      v-model="UserToEdit.email"
                      required
                    />
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-12 col-lg-6">
                  <div class="form-group">
                    <label
                    class="required tooltip-label"
                    data-tooltip="If a user has multiple companies, the primary company must be selected first."
                      >Companies (primary company must be set first)</label
                    >

                    <div
                      style="
                        border: 1px solid #ced4da;
                        border-radius: 0.25rem;
                        transition: border-color 0.15s ease-in-out,
                          box-shadow 0.15s ease-in-out;
                      "
                    >
                      <v-select
                        multiple
                        label="acName"
                        v-model="UserToEdit.ACId"
                        :options="acs"
                        :reduce="(ac) => ac.acid"
                        class="style-chooser"
                        id="adminCompanies"
                        placeholder="Choose Companies"
                        style="background: #f1f6f9 !important"
                        :get-option-label="(ac) => `${ac.acName} (${ac.acid})`"
                      />
                    </div>

                    <!--   

                 <select
                      class="form-control"
                      v-model="UserToEdit.company"
                      required
                    >
                      <option
                        :value="null"
                        class="all-contractors"
                        id="firstSelector"
                        style="text-transform: capitalize !important"
                      >
                        Area Contractor
                      </option>
                      <option
                        v-for="ac in acs"
                        :key="ac.acid"
                        :value="ac.acid"
                        id="text"
                      >
                        {{ " " + ac.acName + " (" + ac.acid + ")" }}
                      </option>
                    </select>
-->
                  </div>

                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="The Rep ID should not have hyphens, they will be removed">Rep ID:</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="EditrepIdInput"
                      required
                      :aria-describedby="error ? 'repId-error' : null"
                      @keypress="onlyNumbers"
                    />
                  </div>

                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Choose a department for the user"> Department: </label>
                    <select
                      class="form-control"
                      v-model="UserToEdit.department"
                      required
                    >
                      <option value="">Select department</option>
                      <option value="EN">Engineering</option>
                      <option value="EA">Engineering Admin</option>
                      <option value="SA">Sales</option>
                      <option value="OP">Operations</option>
                      <option value="NR">North Receiving</option>
                      <option value="EL">Electrical</option>
                      <option value="MC">Material Coordinators</option>
                      <option value="HR">Human Resources</option>
                      <option value="IS">Information Systems</option>
                      <option value="MK">Marketing</option>
                      <option value="SM">Service Managers</option>
                      <option value="SS">Serivce Support</option>
                      <option value="AC">AC Support</option>
                      <option value="AS">AC User</option>
                      <option value="AD">Administrator</option>
                      <option value="FQ">Field Quality</option>
                      <option value="FI">Finance</option>
                      <option value="GS">GSA</option>
                      <option value="JP">Joint Projects</option>
                      <option value="OE">Order Entry</option>
                      <option value="PL">Planning</option>
                      <option value="AP">AC Principal</option>
                      <option value="PC">Production Control</option>
                      <option value="PU">Purchasing</option>
                      <option value="AU">AC Sales</option>
                      <option value="SV">Service</option>
                      <option value="SH">Shipping</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Section 3: Permissions -->
          <div class="form-section">
            <div class="section-container" style="margin-top: 30px;">
              <h2 class="section-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" />
  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
</svg>
                Permissions</h2>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-12 col-lg-6">
                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="User level options vary by selection"> User Type: </label>
                    <select
                      class="form-control"
                      v-model="UserToEdit.userType"
                      required
                    >
                      <option value="">Select user type</option>
                      <option value="7808307F-10F4-4644-8674-70C4BB4C8BDD">
                        SSC Employee(Internal)
                      </option>
                      <option value="4666CBD3-CD25-488B-B508-DCAB6D358372">
                        AC(External)
                      </option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label class="required tooltip-label"
                    data-tooltip="Hover the role for a description."> User Level: </label>
                    <select
                      v-if="
                        UserToEdit.userType ==
                        '7808307F-10F4-4644-8674-70C4BB4C8BDD'
                      "
                      class="form-control"
                      v-model="UserToEdit.userLevel"
                      required
                    >
                      <option value="">Select user level</option>
                      <option value="F9FDA66E-262B-408D-8DEC-7E3F02346588"
                      title="This is the standard role that most plant 1 employees have">
                        SSC Employee
                      </option>
                      <option value="40F1E2BA-1C81-4E8D-9512-A95C2028A1D5"
                      title="This is the same as SSC Empoyee. No elevated permissions">
                        SSC Management
                      </option>
                      <option value="9F2C80F0-A4B2-435A-BFAA-C56088BA71A5"
                      title="This is the standard role that most plant 2 employees have"
                      >
                        SSC Plant 2 Employee
                      </option>
                      <option value="B01B1609-92AC-48F3-A1FE-51785448F8C2"
                      title="This is the same as SSC Empoyee. No elevated permissions">
                        SSC RBM
                      </option>
                      <option value="F3C565C9-C65B-4CC9-868B-B0EF74C837F3"
                      title="This is only used if the user is managing user accounts">
                        Administrator
                      </option>
                    </select>

                    <select
                      v-else
                      class="form-control"
                      v-model="UserToEdit.userLevel"
                      required
                    >
                      <option value="">Select user level</option>
                      <option 
                      value="A9714B0B-6A5C-4524-9A0E-0E6F0D425DF4"
                      title="This role has full company access">
                        AC Principal
                      </option>
                      <option value="D6C4AA1F-22B9-47CF-8386-7FF3E280717A"
                      title="This role will see only their own orders">
                        AC Salesperson
                      </option>
                      <option value="B9AD84BA-7656-447E-8678-2CA8241AF8A6"
                      title="This role is for sales managers. They will see all orders at the company.">
                        AC Admin Assistant
                      </option>
                      <option value="9F173158-5856-4F2E-9B25-BDB7514E060D"
                      title="This role will see all orders at the company.">
                        AC Marketing
                      </option>
                      <option value="F2BA98B3-E5A4-4331-9C6B-DAD131146346"
                      title="This role will see all orders at the company.">
                        AC Installer
                      </option>

                      <!--
                                <option value="manager">Manager</option>
                                <option value="guest">Guest</option>
                                -->
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-12 col-lg-6">
                  <div class="form-group" v-if="UserToEdit.userType == '4666CBD3-CD25-488B-B508-DCAB6D358372'">
                    <label
                    data-tooltip="This applies to only external users. An SSC Employee does not need these."
                        class="tooltip-label"
                        >External Privileges: Not Used for SSC Employees</label>
                    <div>
                      <!--
                               <div class="checkbox-item">
                                    <input type="checkbox" v-model="form.privileges.supportRep" id="supportRep">
                                    <label for="supportRep">Support Rep</label>
                                </div>
                                <div class="checkbox-item">
                                    <input type="checkbox" v-model="form.privileges.announcementAdmin" id="announcementAdmin">
                                    <label for="announcementAdmin">Announcement Admin</label>
                                </div>
                                 <div class="checkbox-item">
                                    <input type="checkbox" v-model="form.privileges.blogAuthor" id="blogAuthor">
                                    <label for="blogAuthor">Blog Author</label>
                                </div>
                                 <div class="checkbox-item">
                                    <input type="checkbox" v-model="form.privileges.onComments" id="onComments">
                                    <label for="onComments">On Comments</label>
                                </div>
                                 <div class="checkbox-item">
                                    <input type="checkbox" v-model="form.privileges.widenAdmin" id="widenAdmin">
                                    <label for="widenAdmin">Widen Admin</label>
                                </div>
                              -->

                      <div
                        class="checkbox-item"
                        style="
                          display: flex;
                          align-items: center;
                          margin-bottom: 10px;
                        "
                      >
                        <input
                          type="checkbox"
                          v-model="UserToEdit.privileges.cashManagement"
                          id="cashManagement"
                          true-value="5D26C210-77BE-41FE-A54E-8599F324A3CF"
                          class="custom-checkbox"
                        />
                        <label for="cashManagement" style="margin-bottom: 0"
                        
                          >Cash Management (Principal approval required)</label
                        >
                      </div>

                      <div
                        class="checkbox-item"
                        style="
                          display: flex;
                          align-items: center;
                          margin-bottom: 10px;
                        "
                      >
                        <input
                          type="checkbox"
                          v-model="UserToEdit.privileges.expeditedOrders"
                          id="expeditedOrders"
                          true-value="355F9223-FAC7-4F66-BE31-396C2ACFC0EC"
                          class="custom-checkbox"
                        />
                        <label for="expeditedOrders" style="margin-bottom: 0"
                          >Expedited Orders</label
                        >
                      </div>
                      <div
                        class="checkbox-item"
                        style="
                          display: flex;
                          align-items: center;
                          margin-bottom: 10px;
                        "
                      >
                        <input
                          type="checkbox"
                          v-model="UserToEdit.privileges.gsa"
                          id="gsa"
                          true-value="42DB7179-4AD2-42EF-83FC-D4E3AA053F00"
                          class="custom-checkbox"
                        />
                        <label for="gsa" style="margin-bottom: 0">GSA</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-actions">
            <button
              type="button"
              class="btn btn-secondary"
              @click="CloseEditModal"
              style="padding: 5px 10px"
            >
              Cancel
            </button>
            <button type="submit" class="btn list-btn">Update Account</button>
          </div>
        </form>
      </div>
    </div>
    <!-- Delete Modal -->
    <div
      v-if="deleteUserOverlay"
      class="overlay"
      :class="deleteUser.length ? 'show block' : 'none'"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="padding: 40px">
          <div
            class="modal-header"
            style="border-bottom: none; padding: 0 1rem"
          >
            <h2 id="exampleModalLabel" style="margin-bottom: 0; line-height: 1">
              Delete User
            </h2>
            <button
              @click="deleteModalClose"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              style="position: absolute; top: 20px; right: 20px"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h5>
              Are you sure you want to delete the user
              {{ UserToDelete.UserFirst + " " + UserToDelete.UserLast }}?
            </h5>
            <p>Enter the user's email to proceed:</p>
            <div class="form-group">
              <label class="required">{{ UserToDelete.Email }}</label>
              <input
                type="text"
                class="form-control"
                v-model="emailConfirmDelete"
                placeholder="User Email"
              />
            </div>
          </div>

          <div class="modal-footer" style="border-top: none">
            <button
              @click="deleteModalClose"
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              style="padding: 5px 10px"
            >
              Cancel
            </button>
            <button
              v-on:click="deleteConfirm(UserToDelete.UserId)"
              v-if="emailConfirmDelete == UserToDelete.Email"
              type="button"
              class="btn list-btn"
            >
              Delete
            </button>
            <button v-else disabled type="button" class="btn list-btn">
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Deactivate Modal -->
    <div
      v-if="deactivateUserOverlay"
      class="overlay"
      :class="deleteUser.length ? 'show block' : 'none'"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="padding: 40px">
          <div
            class="modal-header"
            style="border-bottom: none; padding: 0 1rem"
          >
            <h2 id="exampleModalLabel" style="margin-bottom: 0; line-height: 1">
              Deactivate User
            </h2>
            <button
              @click="deactivateModalClose"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              style="position: absolute; top: 20px; right: 20px"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h5>
              Sure you want to deactivate this user? <br />
              <b>User</b>: {{ UserToDeactivate.userFirst }}
              {{ UserToDeactivate.userLast }}<br />
              <b>Rep ID</b>: {{ UserToDeactivate.RepID }}
            </h5>
            <p></p>
            <div class="form-group">
              <label class="required">Updated email on deactivation:</label>
              <input
                type="text"
                class="form-control"
                v-model="emailConfirmDeactivate"
                placeholder="User Email"
              />
            </div>

            <div class="form-group">
              <label class="required">What is the User's Rep ID?</label>
              <input
                type="text"
                class="form-control"
                v-model="RepIDConfirmDeactivate"
                placeholder="User Rep ID"
              />
            </div>
          </div>

          <div class="modal-footer" style="border-top: none">
            <button
              @click="deactivateModalClose"
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              style="padding: 5px 10px"
            >
              Cancel
            </button>

            <button
              v-on:click="
                deactivateConfirm(
                  UserToDeactivate.userId,
                  UserToDeactivate.Email
                )
              "
              v-if="
                String(UserToDeactivate.RepID) === RepIDConfirmDeactivate &&
                RepIDConfirmDeactivate !== ''
              "
              type="button"
              class="btn list-btn"
            >
              Deactivate
            </button>
            <button v-else type="button" class="btn list-btn" disabled>
              Deactivate
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="deleteUser.length" class="modal-backdrop fade show"></div>

    <section class="py-5 bg10 bs-shadow mobile-top">
      <div class="container">
        <div class="row" data-v-fbf4b22c="">
          <div class="col-xs-12 col-sm-12 col-12 col-lg-5" data-v-fbf4b22c="">
            <div
              style="display: flex; height: 100%; align-items: center"
              data-v-fbf4b22c=""
            >
              <h1
                class="page-heading"
                style="color: #fff; font-size: 31px"
                data-v-fbf4b22c=""
              >
                User Administration
              </h1>
            </div>
          </div>
          <div
            class="col-xs-12 col-sm-12 col-12 col-lg-7"
            style="display: flex; justify-content: center; align-items: center"
          >
            <div style="margin-left: auto"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12" style="margin-bottom: 10px">
            <input
              class="top-search"
              type="text"
              placeholder="Search by First Name"
              style="padding: 15px; margin-bottom: 15px"
              v-model="firstName"
              @keyup.enter.prevent="updateURL"
            />
            <input
              class="top-search"
              type="text"
              placeholder="Search by Last Name"
              style="padding: 15px; margin-bottom: 15px"
              v-model="lastName"
              @keyup.enter.prevent="updateURL"
            />
            <!--
        <input
          class="top-search"
          type="text"
          placeholder="Search by Email"
          style="padding: 15px; margin-bottom: 15px;"
          v-model="lastName"  
        />
        -->

            <select
              class="form-control"
              style="
                height: auto !important;
                padding: 15px !important;
                color: #757575;
              "
              v-model="acFilter"
            >
              <option
                :value="null"
                selected
                class="all-contractors"
                id="firstSelector"
                style="text-transform: capitalize !important"
              >
                Search by Area Contractor
              </option>
              <option
                v-for="ac in acs"
                :key="ac.acid"
                :value="ac.acid"
                id="text"
              >
                {{ " " + ac.acName + " (" + ac.acid + ")" }}
              </option>
              <!--
				>{{ " " + ac.acName + " (" + ac.acid + ")" }}</option>
                -->
            </select>
          </div>
        </div>

        <!--
         <div id="listings-step-2" class="ac-select" style="margin-right: 0; margin-bottom: 10px;">
              <select
                class="form-control"
                id="exampleFormControlSelect1"
                v-model="acFilter"
              >
                <option
                  :value="null"
                  selected
                  class="all-contractors"
                  id="firstSelector"
                  style="text-transform: capitalize !important"
                >
                  Area Contractor
                </option>
                <option
                  v-for="ac in acs"
                  :key="ac.acid"
                  :value="ac.acid"
                  id="text"
                >
                  {{ " " + ac.acName + " (" + ac.acid + ")" }}
                </option>
      
              </select>
            </div>
        -->

        <div class="input-wrap">
          <button
            :class="[showButton ? 'clear-btn' : 'clear-hide']"
            @click="clearSearch"
            type="button"
            class="d-flex align-items-center pr-3 clear-btn"
          >
            <svg
              class="w-4 h-4 text-[#429da8] hover:text-[#1E3040]"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path
                d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
              ></path>
            </svg>
          </button>
        </div>

        <div
          class="search-btns"
          style="display: flex; margin-bottom: 0; margin-top: 0"
        >
          <div class="left-side" style="margin-right: 10px">
            <div
              class="dates"
              id="dates"
              style="display: flex; margin-bottom: 5px"
            ></div>

            <div class="radios">
              <div class="control-group" style="display: flex">
                <label class="control control--radio">
                  Active
                  <input
                    type="radio"
                    name="radio"
                    checked="checked"
                    v-model="active"
                    value="true"
                  />
                  <div class="control__indicator"></div>
                </label>
                <label class="control control--radio">
                  Inactive
                  <input
                    type="radio"
                    name="radio"
                    v-model="active"
                    value="false"
                  />
                  <div class="control__indicator"></div>
                </label>
                <!--
                <label id="EO-step-3" class="control control--radio">
                  Completed
                  <input
                    type="radio"
                    name="radio"
                    v-model="picked"
                    value="completed"
                  />
                  <div class="control__indicator"></div>
                </label>
                -->
              </div>
            </div>
          </div>

          <div class="right-side" style="display: flex">
            <div
              class="search-btns"
              style="display: flex; margin-top: 0; margin-left: auto"
            >
              <button
                v-if="firstName || lastName || acFilter"
                @click.prevent="searchReset"
                class="search"
                style="margin-right: 5px"
              >
                <span class="material-icons">search</span>
                {{ " " }} Clear
              </button>

              <button v-else disabled class="search" style="margin-right: 5px">
                <span class="material-icons">search</span>
                {{ " " }} Clear
              </button>

              <button @click.prevent="updateURL" class="search">
                <span class="material-icons">search</span>
                {{ " " }} Search
              </button>
              <!--
                <button v-else class="search" disabled>
                <span class="material-icons">search</span>
                {{ " " }} Search
              </button>
              -->

              <!--
              <button
                v-if="searchValue || startDate || endDate || acFilter"
                @click="clearSearch"
                class="clear"
              >
                <span class="material-icons">find_replace</span>
                {{ " " }} Clear
              </button>
              <button v-else disabled class="clear">
                <span class="material-icons">find_replace</span>
                {{ " " }} Clear
              </button>
              -->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div style="display: flex">
              <button
                class="search"
                style="
                  padding: 5px 10px;
                  margin-left: initial;
                  margin-right: 5px;
                "
                @click="openUserModal"
              >
                Create New User
              </button>
              <download-csv
                class="search"
                style="padding: 5px 10px; margin-left: initial"
                :data="filteredUserDownload"
                :name="'userlist' + '.csv'"
                >Download User List</download-csv
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="container">
      <div class="row">
        <!--
        <div class="col-lg-4 d-none d-lg-block">
          <div class="card-block my-3 bs-shadow">
            <h5 class="dflex">
              <i class="material-icons">help</i> Using the Admin Section
            </h5>
            <hr />
            <div>
              <p class="info-box">
                You can search above by a user's first name, last name, or by
                company name of their employer.
              </p>
              <p class="info-box mb0">
                You can also filter your results by clicking on the company name
                in the user results area.
              </p>
            </div>
          </div>
        </div>
        -->

        <div
          v-if="loading == true"
          class="col-xs-12 col-sm-12 col-12 col-lg-12"
        >
          <div class="flex-box-wrap" style="margin: 150px 0">
            <div class="flex-internal">
              <atom-spinner
                :animation-duration="1000"
                :size="40"
                :color="'#575757'"
              />
              <p>Loading......</p>
            </div>
          </div>
        </div>

        <div
          v-else-if="loading == false && !filteredUsers.length"
          class="col-xs-12 col-sm-12 col-12 col-lg-12 flexVHcenter"
        >
          <div style="margin: 150px 0">
            <img src="@/assets/img/sad.svg" />
            <p>Sorry, nothing was found...</p>
          </div>
        </div>

        <div v-else class="col-xs-12 col-sm-12 col-12 col-lg-12">
          <div
            class="user-header d-flex align-items-center p-3 mb5 mt1r rounded bs-shadow"
          >
            <div class="d-flex number-showing">
              <p class="mb0">
                Page {{ currPage }} of
                {{ Math.ceil(this.filteredUsers.length / 25) }}
              </p>
            </div>

            <div class="pag-wrapper mlauto">
              <div class="nav-btns">
                <button v-if="this.currPage === 1" disabled>
                  <i class="material-icons">keyboard_arrow_left</i> Back
                </button>

                <button v-else @click.prevent="setPage(currPage - 1)">
                  <i class="material-icons">keyboard_arrow_left</i> Back
                </button>

                <button
                  v-if="
                    this.currPage === this.totalPage ||
                    this.currPage == Math.ceil(this.filteredUsers.length / 25)
                  "
                  disabled
                >
                  Next
                  <i class="material-icons">keyboard_arrow_right</i>
                </button>

                <button v-else @click.prevent="setPage(currPage + 1)">
                  Next
                  <i class="material-icons">keyboard_arrow_right</i>
                </button>
              </div>
            </div>
          </div>

          <div>
            <div
              v-bind:key="user.Tid"
              v-for="(user, index) in filteredUsers.slice(
                pageStart,
                pageStart + countOfPage
              )"
            >
              <!--
          <div v-for="user in users" :key="user.Tid">
              -->
              <div
                class="user bs-shadow br4"
                :class="user.IsActive == false ? 'inactive' : ''"
                :key="index"
              >
                <div class="top-wrap">
                  <div class="dflex mb0">
                    <avatar
                      class="mr5"
                      color="#fff"
                      :username="user.FirstName + ' ' + user.LastName"
                      :backgroundColor="
                        colorGetter[
                          Math.floor(Math.random() * colorGetter.length)
                        ]
                      "
                    ></avatar>
                    <!--
                    <avatar
                      class="mr10"
                      color="#fff"
                      v-bind:username="user.FirstName + ' ' + user.LastName"
                      v-bind:backgroundColor="
												colorGetter[
													Math.floor(Math.random() * colorGetter.length)
												]
											"
                    ></avatar>
                  -->
                    <!--
                  {{colorGetter[Math.floor(Math.random() * colorGetter.length)]}}
                    -->
                    <div class="dflex vcenter">
                      <div>
                        <h6 class="mb5">
                          <b>{{ user.FirstName + " " + user.LastName }} </b>
                        </h6>
                        <p v-if="user.Email" class="dflex mb5 l1 text-muted">
                          <small style="display: flex; justify-content: center;">
                            <span class="material-icons" style="font-size: 14px; margin-right: 5px;">email</span>
                            <b class="user-link">
                              <a v-bind:href="`mailto:${user.Email}`">
                                <span>{{ user.Email }}</span>
                              </a>
                            </b>
                          </small>
                        </p>
                        <p
                          v-if="user.PhoneNumber"
                          class="dflex mb5 l1 text-muted"
                        >
                        <small style="display: flex; justify-content: center;">
                            <span class="material-icons" style="font-size: 14px; margin-right: 5px;">phone</span>
                            {{ user.PhoneNumber }}
                          </small>
                        </p>
                        <p class="dflex mb5 l1 text-muted" title="Last login date" style="display: flex; align-items: center;">
                          <svg style="font-size: 14px; margin-right: 5px;" xmlns="http://www.w3.org/2000/svg" height="16px"  width="15px" viewBox="0 -960 960 960"  fill="#6c757ds"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 27-3 53t-10 51q-14-16-32.5-27T794-418q3-15 4.5-30.5T800-480q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93q51 0 97.5-15t85.5-42q12 17 29.5 30t37.5 20q-51 41-114.5 64T480-80Zm290-160q-21 0-35.5-14.5T720-290q0-21 14.5-35.5T770-340q21 0 35.5 14.5T820-290q0 21-14.5 35.5T770-240Zm-158-52L440-464v-216h80v184l148 148-56 56Z"/></svg>
                          {{ $moment(user.LastLoginDate).format("MM-DD-YYYY") }}</p>
                       

                      </div>
                      
                    </div>
                   
                  </div>

                  <div class="company-link mlauto">
                    <p data-v-33bc25df="" class="lh1 mb0 company-button" style="background: rgb(231, 237, 241); color: #575757; padding: 10px; font-size: 14px;">
                      {{ user.Name }}
                    </p>
                    
                    

                  </div>
                  
                </div>
                <div class="role-container" style="margin-top: 10px; display: flex; flex-wrap: wrap; gap: 5px;">
                          <div v-for="role in getRoleNames(user.RoleIds)" :key="role" class="role-item">
                            <p class="lh1 mb0 company-button" style="margin-right: 5px; padding: 5px;">
                              <small>{{ role }}</small>
                            </p>
                          </div>
                        </div>
                <div style="display: flex">
                <div class="admin-btn-wrap">
                  <button
                    @click.prevent="impersonate(user.UserId, user.Email)"
                    v-if="user.IsActive"
                    class="admin-buttons"
                    title="If you impersonate a user, always refresh your browser afterwards to make sure you get their updated list of companies and permissions."
                  >
                    Impersonate
                  </button>
                  <button
                    @click.prevent="
                      deactivateUserAccount(
                        user.FirstName,
                        user.LastName,
                        user.UserId,
                        user.Email,
                        user.RepId
                      )
                    "
                    v-if="user.IsActive"
                    class="admin-buttons"
                    style="background: #5c6d7ee6;"
                    title="This is a quick deactivate. Users can be deactivated in edit as well."
                  >
                    Deactivate
                  </button>
                  <!--
                   <button
                    @click.prevent="
                      activateUserAccount(
                        user.FirstName,
                        user.LastName,
                        user.UserId,
                        user.Email,
                        user.RepId
                      )
                    "
                    v-if="!user.IsActive"
                    class="admin-buttons"
                  >
                    Activate
                  </button>
                  -->
                 

                  <!--
                   <button
                    @click.prevent="clearPrinted(user.UserId)"
                    class="admin-buttons"
                  >
                    Clear Printed
                  </button>
                  -->

                  <!--
                  <button v-else disabled class="admin-buttons disabled">Impersonate</button>
                  -->

                  <button @click="openEditModal(user)" class="admin-buttons">
                    Edit
                  </button>
                  <button
                    @click.prevent="
                      deleteUserAccount(
                        user.FirstName,
                        user.LastName,
                        user.UserId,
                        user.Email
                      )
                    "
                    class="admin-buttons"
                    style="background: #4d5967!important;"
                  >
                    Delete
                  </button>
                </div>

               <div style="margin-left: auto;">
                <span v-if="user.IsActive" style="display: flex; align-items: center;">
                  <span>
                  <svg style="width: 25px;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
</svg>
</span>
                  <!-- <span style="color: #28a745;">✔</span> -->
                   <span>Active</span></span>
                <span v-else style="display: flex; align-items: center;">
                  <!--
                  <span style="color: #6c757d;">✖</span>
                  -->
                  <svg style="width: 25px;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
                  <span>Inactive</span>
                </span>
                
              </div>

              </div>
           
                <!--
              <div class="user-info">
                <p v-if="user.Email" class="dflex mb10 l1"><i class="fas fa-envelope mr5"></i><b><span :href="`mailto:${user.Email}`">{{user.Email}}</span></b></p>
                <p v-if="user.PhoneNumber" class="dflex mb0 l1"><i class="fas fa-phone mr5"></i> {{user.PhoneNumber}}</p>
              </div>
                -->
              </div>
              <!-- card -->
            </div>
          </div>

          <!-- bottom pagination -->
          <div
            class="user-header d-flex align-items-center p-3 mb5 mt5 mb1r rounded box-shadow"
          >
            <div class="d-flex number-showing">
              <p class="mb0">
                Page {{ currPage }} of
                {{ Math.ceil(this.filteredUsers.length / 25) }}
              </p>
            </div>

            <div class="pag-wrapper mlauto">
              <div class="nav-btns">
                <button v-if="this.currPage === 1" disabled>
                  <i class="material-icons">keyboard_arrow_left</i> Back
                </button>

                <button v-else @click.prevent="setPage(currPage - 1)">
                  <i class="material-icons">keyboard_arrow_left</i> Back
                </button>

                <button
                  v-if="
                    this.currPage === this.totalPage ||
                    this.currPage == Math.ceil(this.filteredUsers.length / 25)
                  "
                  disabled
                >
                  Next
                  <i class="material-icons">keyboard_arrow_right</i>
                </button>

                <button v-else @click.prevent="setPage(currPage + 1)">
                  Next
                  <i class="material-icons">keyboard_arrow_right</i>
                </button>
              </div>
            </div>
          </div>
          <!-- end bottom pagination -->
        </div>
        <!-- end other column -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
import Avatar from "../components/Atoms/Avatar.vue";
import JsonCSV from "vue-json-csv";
import vSelect from "vue-select";
import { thresholdSturges } from "d3";

const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
    //Authorization: "Bearer " + wontworkqwd2iwedjqoewiudwo
  },
};

export default {
  name: "Admin",
  components: {
    AtomSpinner,
    Avatar,
    JsonCSV,
    vSelect,
  },
  data() {
    return {
      server: import.meta.env.VITE_APP_SERVER_URL,
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      staging: "http://localhost:5002/api/v1/admin/user/create",
      stage: "http://localhost:5002",
      search: "",
      firstName: "",
      lastName: "",
      selectedCompany: "",
      active: true,
      acs: [],
      users: [],
      selectedCat: 0,
      loading: true,
      countOfPage: 25,
      currPage: 1,
      noUserFound: false,
      deleteUser: "",
      acFilter: null,
      showNewUserOverlay: false,
      showEditUserOverlay: false,
      deleteUserOverlay: false,
      deactivateUserOverlay: false,
      activateUserOverlay: false,
      emailConfirmDelete: null,
      emailConfirmDeactivate: null,
      RepIDConfirmDeactivate: null,
      emailConfirmActivate: null,
      RepIDConfirmActivate: null,
      UserToActivate: {
        userFirst: null,
        userLast: null,
        userId: null,
        Email: null,
        RepID: null,
      },
      UserToDeactivate: {
        userFirst: null,
        userLast: null,
        userId: null,
        Email: null,
        RepID: null,
      },
      newpassword: "",
      UserToDelete: {
        uerFirst: null,
        uerLast: null,
        userId: null,
        Email: null,
      },
      form: {
        userName: "",
        password: this.newpassword,
        confirmPassword: this.newpassword,
        email: "",
        securityQuestion: "What is your username?",
        securityAnswer: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        company: "0",
        repId: "0",
        department: "",
        userType: "",
        userLevel: "",
        privileges: {
          gsa: false,
          cashManagement: false,
          expeditedOrders: false,
        },
        ACId: [],
      },
      UserToEdit: {
        userID: "",
        userName: "",
        email: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        company: "0",
        repId: "0",
        department: "",
        userType: "",
        userLevel: "",
        privileges: {
          gsa: false,
          cashManagement: false,
          expeditedOrders: false,
        },
      },
      Roles: [
        { id: "F9FDA66E-262B-408D-8DEC-7E3F02346588", name: "SSC Employee" },
        { id: "40F1E2BA-1C81-4E8D-9512-A95C2028A1D5", name: "SSC Management" },
        { id: "9F2C80F0-A4B2-435A-BFAA-C56088BA71A5", name: "SSC Plant 2 Employee" },
        { id: "B01B1609-92AC-48F3-A1FE-51785448F8C2", name: "SSC RBM" },
        { id: "F3C565C9-C65B-4CC9-868B-B0EF74C837F3", name: "Administrator" },
        { id: "A9714B0B-6A5C-4524-9A0E-0E6F0D425DF4", name: "AC Principal" },
        { id: "D6C4AA1F-22B9-47CF-8386-7FF3E280717A", name: "AC Salesperson" },
        { id: "B9AD84BA-7656-447E-8678-2CA8241AF8A6", name: "AC Admin Assistant" },
        { id: "9F173158-5856-4F2E-9B25-BDB7514E060D", name: "AC Marketing" },
        { id: "F2BA98B3-E5A4-4331-9C6B-DAD131146346", name: "AC Installer" },
        { id: "7808307F-10F4-4644-8674-70C4BB4C8BDD", name: "SSC Employee (Internal)" },
        { id: "4666CBD3-CD25-488B-B508-DCAB6D358372", name: "AC (External)" },
        { id: "5D26C210-77BE-41FE-A54E-8599F324A3CF", name: "cashManagement" },
        { id: "355F9223-FAC7-4F66-BE31-396C2ACFC0EC", name: "expeditedOrders" },
        { id: "42DB7179-4AD2-42EF-83FC-D4E3AA053F00", name: "gsa" },
      ]
    };
  },
  methods: {
    firstLoad: function () {
      this.loading = true;
      this.$store.commit("setActivePage", "Admin");

      const urlParams = new URLSearchParams(window.location.search);
      const FirstName = urlParams.get("first");
      const LastName = urlParams.get("last");
      const Company = urlParams.get("company");
      const Active = urlParams.get("active") || this.active;

      // Build the URL parameters based on the extracted parameters only when they exist
      const queryParams = [];

      if (FirstName) {
        queryParams.push(`first=${encodeURIComponent(FirstName)}`);
        this.firstName = FirstName;
      }
      if (LastName) {
        queryParams.push(`last=${encodeURIComponent(LastName)}`);
        this.lastName = LastName;
      }
      if (Company) {
        queryParams.push(`company=${encodeURIComponent(Company)}`);
        this.acFilter = Company;
      }
      if (Active) {
        queryParams.push(`active=${encodeURIComponent(Active)}`);
        this.active = Active;
      }

      // Join all the query parameters with '&'
      const queryString = queryParams.join("&");

      // Construct the final URL
      const apiUrl = `${this.server}/api/v1/admin?${queryString}`;
      console.log("string " + queryParams);
      console.log("url " + apiUrl);

      const requestUrl = this.firstName || this.lastName || this.acFilter || this.active 
        ? apiUrl 
        : `${this.server}/api/v1/admin`;

      return axios
        .get(requestUrl, auth)
        .then((response) => {
          console.log(response);
          this.users = response.data.users;
          this.acListSync();
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error in API request:", error);
          if (error.response && error.response.status === 401) {
            // this.Logout(); // Uncomment if you want to trigger logout
            this.$router.push("/");
          } else {
            // Handle other errors if needed
            this.loading = false;
          }
        });
    },
    onlyNumbers(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      if (!/[0-9]/.test(char)) {
        event.preventDefault();
      }
    },
    closeOverlay() {
      this.showNewUserOverlay = false;
      this.form = {
        userName: "",
        password: this.newpassword,
        confirmPassword: this.newpassword,
        email: "",
        securityQuestion: "What is your username?",
        securityAnswer: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        company: "0",
        repId: "0",
        department: "",
        userType: "",
        userLevel: "",
        privileges: {
          gsa: false,
          cashManagement: false,
          expeditedOrders: false,
        },
        ACId: [],
      };
    },
    getRoleNames(roleIds) {
      return (roleIds || []).map((roleId) => {
        const role = this.Roles.find((r) => r.id === roleId);
        return role ? role.name : null;
      }).filter(name => name !== null); // Remove null values
    },
    submitForm() {
      // Validate passwords match
      if (this.form.password !== this.form.confirmPassword) {
        alert("Passwords do not match!");
        return;
      }

      return axios
        .post(`${this.server}/api/v1/admin/user/create`, this.form, auth)
        .then((response) => {
          if (response.status === 401) {
              // this.Logout();
              this.$router.push("/");
          } else {
            console.log("Response:", response);
            this.$toast.success("User successfully created and notification sent", {
              hideProgressBar: false,
              position: "bottom-right",
              icon: false,
              timeout: 10000,
            });
            this.firstLoad();
            this.showNewUserOverlay = false;
            this.form = {};
          }

          // const data = response.data;
        })
        .catch((error) => {
          // console.error('Error during POST request:', error);
          this.$toast.error(error.response.data.error, {
            hideProgressBar: false,
            position: "bottom-right",
            icon: false,
            timeout: 10000,
          });
          // throw error; // Re-throw the error to propagate it if needed
        });

      /*
      console.log("Form submitted:", this.form);
      alert("Account created successfully!");
      this.resetForm();
      this.closeOverlay();
      */
    },
    submitEditForm() {     
      this.UserToEdit.company = this.UserToEdit.ACId[0]
      // alert("made first in submit")
      // console.log(JSON.stringify(this.UserToEdit))


      
      return axios
        .post(`${this.server}/api/v1/admin/user/update`, this.UserToEdit, auth)
        .then((response) => {
          console.log("Response:", response);
          this.$toast.success("User successfully updated", {
            hideProgressBar: false,
            position: "bottom-right",
            icon: false,
            timeout: 10000,
          });
          this.firstLoad();
          this.showEditUserOverlay = false;
          this.UserToEdit = {};
        })
        .catch((error) => {
          // console.error('Error during POST request:', error);
          this.$toast.error(error.response.data.error, {
            hideProgressBar: false,
            position: "bottom-right",
            icon: false,
            timeout: 10000,
          });
        });
    

    },
    resetForm() {
      this.form = {
        userName: "",
        password: "",
        confirmPassword: "",
        email: "",
        securityQuestion: "",
        securityAnswer: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        company: "0",
        repId: "0",
        department: "",
        userType: "",
        userLevel: "",
        privileges: {
          gsa: false,
          cashManagement: false,
          expeditedOrders: false,
        },
      };
    },

    generatePassword() {
      const lowercase = "abcdefghijklmnopqrstuvwxyz";
      const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const numbers = "0123456789";
      const special = "!@#$%^&*()_+-="; // Added special characters
      const allChars = lowercase + uppercase + numbers + special;

      // Ensure at least one of each required character
      const getRandomChar = (str) =>
        str[Math.floor(Math.random() * str.length)];
      let password = [
        getRandomChar(lowercase), // One lowercase
        getRandomChar(uppercase), // One uppercase
        getRandomChar(numbers), // One number
        getRandomChar(special), // One special character
      ];

      // Fill remaining length (minimum 12, so add 8+ random chars)
      const remainingLength = Math.max(12 - password.length, 8); // Ensure at least 12 chars
      for (let i = 0; i < remainingLength; i++) {
        password.push(getRandomChar(allChars));
      }

      // Shuffle the password array
      for (let i = password.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [password[i], password[j]] = [password[j], password[i]];
      }

      this.newpassword = password.join("");
    },

    acListSync: function () {
      this.loading = true;


        return axios
          .get(`${this.ordermanageapi}/aclist`, auth)
          .then((response) => {
            console.log(response);
            const data = response.data;
            //this.acs = alph;
            const alph = Array.isArray(data)
              ? data.sort((a, b) => (a.acName > b.acName ? 1 : -1))
              : [];
            this.acs = alph;
            this.$store.commit("UPDATE_ACLIST", this.acs);
          });

    },

    updateURL() {
      const queryParams = [];
      //const page = urlParams.get("page") || "";
      if (this.firstName.trim().length > 0) {
        queryParams.push(`first=${encodeURIComponent(this.firstName.trim())}`);
      }
      if (this.lastName.trim().length > 0) {
        queryParams.push(`last=${encodeURIComponent(this.lastName.trim())}`);
      }
      if (this.acFilter !== null && this.acFilter !== undefined) {
        queryParams.push(`company=${encodeURIComponent(this.acFilter)}`);
      }
      if (this.active || !this.active) {
        queryParams.push(`active=${encodeURIComponent(this.active)}`);
      }

      const newURL = `${window.location.pathname}?${queryParams.join("&")}`;
      window.history.pushState({}, "", newURL);
      this.firstLoad();
      // window.location.href = newURL;
    },

    searchReset: function () {
      this.firstName = "";
      this.lastName = "";
      this.acFilter = null;
      this.active = true;
      this.updateURL();
    },

    setPage: function (idx) {
      this.search = "";
      if (idx <= 0 || idx > this.totalPage) {
        return;
      }
      this.currPage = idx;
    },

    catSwitcher: function (catID) {
      let category = catID;
      if (category !== 0) {
        this.selectedCat = category;
        this.search = "";
        console.log(category);
      } else {
        this.selectedCat = 0;
      }
    },

    setCompany(c) {
      this.search = "";
      let company = c;
      this.selectedCompany = company;
    },
    impersonate(id, email) {
      var postData = {
        id: id,
        email: email,
      };

      console.log(postData);

      this.$store
        .dispatch("impersonateUser", postData)
        .then(() => {
          // this.$noty.success("Successfully logged in!");
          
          this.$router.push("/Home");
          
        })
        .catch((err) => {
          //console.log(err)
          this.feedback = "There seems to be an issue with your credentials.";
        });
    },
    deleteUserAccount(first, last, id, email) {
      console.log(id);
      console.log(email);
      this.deleteUserOverlay = true;
      this.UserToDelete = {
        UserFirst: first,
        UserLast: last,
        UserId: id,
        Email: email,
      };
    },
    deleteConfirm(id) {
      console.log(id);
      const deleteURL = this.server + "/api/v1/admin/user/delete"; // Declare with const
      console.log(`${deleteURL}`);
      return axios
        .post(
          `${deleteURL}`,
          {
            userID: id,
          },
          auth
        )
        .then((response) => {
          console.log("Response:", response);
          if (response.status === 401) {
              // this.Logout();
              this.$router.push("/");
          } else {
          this.firstName = ""
          this.lastName = ""
          this.$router.replace({
            ...this.$route,
            query: {}, // Set query to an empty object to remove all params
          });
          this.deleteModalClose();
          this.firstLoad();
          this.$toast.success(
            `The user has been successfully deleted`,
            {
              hideProgressBar: false,
              position: "bottom-right",
              icon: false,
              timeout: 10000,
            }
          );
          }
        })
        .catch((error) => {
          console.error("Error during POST request:", error);
          this.$toast.error(
            `There was an issue deleting ${
              this.UserToDelete.UserFirst + " " + this.UserToDelete.UserLast
            }`,
            {
              hideProgressBar: false,
              position: "bottom-right",
              icon: false,
              timeout: 10000,
            }
          );
        });
    },

    activateUserAccount(FirstName, LastName, UserId, Email, RepID) {
      this.activateUserOverlay = true;
      this.emailConfirmActivate = Email;
      this.RepIDConfirmActivate = null;
      this.UserToActivate.userFirst = FirstName;
      this.UserToActivate.userLast = LastName;
      this.UserToActivate.userId = UserId;
      this.UserToActivate.Email = Email;
      this.UserToActivate.RepID = RepID;
    },
    deactivateUserAccount(FirstName, LastName, UserId, Email, RepID) {
      this.deactivateUserOverlay = true;
      this.emailConfirmDeactivate = "TERM" + Email;
      this.RepIDConfirmDeactivate = null;
      this.UserToDeactivate.userFirst = FirstName;
      this.UserToDeactivate.userLast = LastName;
      this.UserToDeactivate.userId = UserId;
      this.UserToDeactivate.Email = Email;
      this.UserToDeactivate.RepID = RepID;
    },

    deactivateConfirm(UserId, Email) {
      console.log(UserId, Email);
      const deactivateURL = this.server + "/api/v1/admin/user/deactivate"; // Declare with const
      console.log(`${deactivateURL}`);
      return axios
        .post(
          `${deactivateURL}`,
          {
            UserID: UserId,
            Email: Email,
          },
          auth
        )
        .then((response) => {
          console.log("Response:", response);
          this.$toast.success(
            `The user has been successfully deactivated`,
            {
              hideProgressBar: false,
              position: "bottom-right",
              icon: false,
              timeout: 10000,
            }
          );
          this.deactivateModalClose();
          this.firstLoad();
        })
        .catch((error) => {
          console.error("Error during POST request:", error);
          this.$toast.error(`There was an issue deactivating this user`, {
            hideProgressBar: false,
            position: "bottom-right",
            icon: false,
            timeout: 10000,
          });
        });
    },
    deactivateModalClose() {
      this.deactivateUserOverlay = false;
      this.emailConfirmDeactivate = null;
      this.RepIDConfirmDeactivate = null;
      this.UserToDeactivate = {};
    },
    openEditModal(user) {
      // Set basic user fields
      this.UserToEdit.userName = user.LoweredUserName;
      this.UserToEdit.email = user.LoweredEmail;
      this.UserToEdit.firstName = user.FirstName;
      this.UserToEdit.lastName = user.LastName;
      this.UserToEdit.company = user.ACId;
      
      this.UserToEdit.phoneNumber = user.PhoneNumber;
      this.UserToEdit.department = user.Department;
      this.UserToEdit.userID = user.UserId;
      this.UserToEdit.repId = user.RepId;
      this.UserToEdit.active = user.IsActive;

      // Find User Type from Array
      const validUserTypeIds = [
        "7808307F-10F4-4644-8674-70C4BB4C8BDD", // SSC Employee (Internal)
        "4666CBD3-CD25-488B-B508-DCAB6D358372", // AC (External)
      ];
      const matchingUserTypeId = user.RoleIds.find((roleId) =>
        validUserTypeIds.includes(roleId)
      );
      this.UserToEdit.userType = matchingUserTypeId || "";

      // Find User Level from Array
      const sscRoleIds = [
        "F9FDA66E-262B-408D-8DEC-7E3F02346588", // SSC Employee
        "40F1E2BA-1C81-4E8D-9512-A95C2028A1D5", // SSC Management
        "9F2C80F0-A4B2-435A-BFAA-C56088BA71A5", // SSC Plant 2 Employee
        "B01B1609-92AC-48F3-A1FE-51785448F8C2", // SSC RBM
        "F3C565C9-C65B-4CC9-868B-B0EF74C837F3", // Administrator
      ];
      const acRoleIds = [
        "A9714B0B-6A5C-4524-9A0E-0E6F0D425DF4", // AC Principal
        "D6C4AA1F-22B9-47CF-8386-7FF3E280717A", // AC Salesperson
        "B9AD84BA-7656-447E-8678-2CA8241AF8A6", // AC Admin Assistant
        "9F173158-5856-4F2E-9B25-BDB7514E060D", // AC Marketing
        "F2BA98B3-E5A4-4331-9C6B-DAD131146346", // AC Installer
      ];

      // Choose the appropriate role ID list based on userType
      const validUserLevelIds =
        this.UserToEdit.userType === "7808307F-10F4-4644-8674-70C4BB4C8BDD"
          ? sscRoleIds
          : acRoleIds;

      // Find the first matching role ID for userLevel
      this.UserToEdit.userLevel =
        user.RoleIds.find((roleId) => validUserLevelIds.includes(roleId)) || "";

      // Set Privileges based on RoleIds
      const privilegeGuids = {
        cashManagement: "5D26C210-77BE-41FE-A54E-8599F324A3CF",
        expeditedOrders: "355F9223-FAC7-4F66-BE31-396C2ACFC0EC",
        gsa: "42DB7179-4AD2-42EF-83FC-D4E3AA053F00",
      };

      this.UserToEdit.privileges = {
        cashManagement: user.RoleIds.includes(privilegeGuids.cashManagement)
          ? privilegeGuids.cashManagement
          : false,
        expeditedOrders: user.RoleIds.includes(privilegeGuids.expeditedOrders)
          ? privilegeGuids.expeditedOrders
          : false,
        gsa: user.RoleIds.includes(privilegeGuids.gsa)
          ? privilegeGuids.gsa
          : false,
      };

      // this just sets the array
      // this.UserToEdit.ACId = [...user.CompanyIds];

      //this makes primary company last
      /*
      this.UserToEdit.ACId = [...user.CompanyIds].sort((a, b) => {
        // If a matches company, push it to the end (return 1)
        if (a === this.UserToEdit.company) return 1;
        // If b matches company, keep it at the end (return -1)
        if (b === this.UserToEdit.company) return -1;
        // Otherwise, maintain original order (or sort numerically if desired)
        return 0; // or return a - b for numerical sorting
      });
      alert("made last");
      */

      // This makes primary first

      this.UserToEdit.ACId = [...user.CompanyIds].sort((a, b) => {
        // If a matches company, place it first (return -1)
        if (a === this.UserToEdit.company) return -1;
        // If b matches company, place it first (return 1)
        if (b === this.UserToEdit.company) return 1;
        // Otherwise, maintain original order (or sort numerically if desired)
        return 0; // or return a - b for numerical sorting
      });
      this.UserToEdit.company = this.UserToEdit.ACId[0]
      this.showEditUserOverlay = true;
    },

    CloseEditModal() {
      this.showEditUserOverlay = false;
      this.UserToEdit = {};
    },

    openUserModal() {
      this.generatePassword();
      this.form.password = this.newpassword;
      this.form.confirmPassword = this.newpassword;
      this.showNewUserOverlay = true;
    },
    deleteModalClose() {
      this.deleteUserOverlay = false;
      this.UserToDelete = {};
      this.emailConfirmDelete = "";
    },
    cancelModal() {
      this.deleteUser = "";
      document.body.classList.remove("modal-open");
    },
    insertUser() {},
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      //return value.charAt(0).toUpperCase() + value.slice(1)
      return value.charAt(0) + value.slice(1).toLowerCase();
    },
  },
  computed: {
    activeNav() {
      return this.$store.state.activePage;
    },
    repIdInput: {
      get() {
        return this.form.repId.toString(); // Convert to string for input display
      },
      set(value) {
        // Remove hyphens and non-numeric characters, keep only digits
        const sanitized = value.replace(/[^0-9]/g, '');
        // Convert to integer (or 0 if empty/invalid)
        const parsed = sanitized ? parseInt(sanitized, 10) : 0;
        this.form.repId = parsed;
        // Validate
        if (!sanitized || isNaN(parsed)) {
          this.error = 'Please enter a valid integer';
        } else {
          this.error = '';
        }
      },
    },
    EditrepIdInput: {
      get() {
        return this.UserToEdit.repId.toString(); // Convert to string for input display
      },
      set(value) {
        // Remove hyphens and non-numeric characters
        const sanitized = value.replace(/[^0-9]/g, '');
        // Convert to integer (or 0 if empty/invalid)
        const parsed = sanitized ? parseInt(sanitized, 10) : 0;
        this.UserToEdit.repId = parsed;
        // Validate
        if (!sanitized || isNaN(parsed)) {
          this.error = 'Please enter a valid integer';
        } else {
          this.error = '';
        }
      },
    },

    colorGetter() {
      return this.$store.state.colors;
    },

    filteredUserDownload() {
      return this.users.map((user) => ({
        Email: user.Email === undefined || user.Email === null ? "" : user.Email,
        FirstName: user.FirstName === undefined || user.FirstName === null ? "" : user.FirstName,
        LastName: user.LastName === undefined || user.LastName === null ? "" : user.LastName,
        ACId: user.ACId === undefined || user.ACId === null ? null : user.ACId,
        RepId: user.RepId === undefined || user.RepId === null ? null : user.RepId,
        PhoneNumber: user.PhoneNumber === undefined || user.PhoneNumber === null ? "" : user.PhoneNumber,
        Department: user.Department === undefined || user.Department === null ? "" : user.Department,
        Company: user.Name === undefined || user.Name === null ? "" : user.Name,
        IsActive: user.IsActive !== undefined ? user.IsActive : false,
        LastLogin: user.LastLoginDate !== undefined ? user.LastLoginDate : null,
        Roles: this.getRoleNames(user.RoleIds).join(", ") // Comma-separated roles
      }));
    },

    filteredACs: function () {
      let b = this.acs.filter(function (e) {
        return e.ACID <= 200;
      });

      return b;
    },

    //the main v-for loop for the users
    filteredUsers: function () {
      //set the current page to 0
      this.currPage = 1;
      //if the search box is filled in
      if (this.search.trim() !== "") {
        return this.users.filter((e) => {
          return (
            e.FirstName.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
            e.LastName.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
            e.Name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );

          //filter the subject line by what is filled in the search box
          //return e.LastName.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        });
      } else if (this.selectedCompany !== "") {
        this.search = "";
        //console.log(this.selectedCat);
        return this.users.filter((f) => {
          return f.Name == this.selectedCompany;
        });
      } else {
        //if the search box is not filled in
        return this.users;
      }
    },

    foundNoUser: function () {
      if (this.search.length > 1 && this.filteredUsers.length === 0) {
        //this.noUserFound = true;
        return true;
      }
    },

    pageStart: function () {
      return (this.currPage - 1) * this.countOfPage;
    },

    totalPage: function () {
      return Math.ceil(this.users.length / this.countOfPage);
    },
  },
  created() {
    this.$store.commit("showNavigation");
    // console.log(this.$route.path);
  },
  mounted() {
    this.firstLoad();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #00b4b4;
  border-color: #00b4b4;
}

.user {
  background-color: #fff;
  line-height: 44px;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}

.top-wrap {
  display: flex;
  align-items: flex-start;
}

.user-bottom {
  align-items: flex-end;
}

.user-header {
  background: #fff;
  color: #575757;
  display: flex !important;
}

.capitalize {
  text-transform: capitalize;
}

.l1 {
  line-height: 1;
}
.mb5 {
  margin-bottom: 5px;
}
.mb10 {
  margin-bottom: 10px;
}
.mr5 {
  margin-right: 5px;
}
.mr10 {
  margin-right: 10px;
}
.mlauto {
  margin-left: auto;
}

.user-link {
  color: #429da8;
  cursor: pointer;
}
.user-link a {
  color: #429da8;
  cursor: pointer;
}
.company-button {
  background: rgb(231 237 241);color: #575757;
  padding: 5px;
  border-radius: 5px;
  transition: background-color 0.5s ease;
}

.info-box {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 2px;
}
.inactive {

}
.admin-buttons {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #429da8;
  color: #fff;
  border-radius: 4px;
  line-height: 1;
  padding: 5px 10px;
  margin-right: 5px;
  cursor: pointer;
}
.admin-btn-wrap {
  display: flex;
  margin-top: 10px;
}
.disabled {
  background-color: #000;
  color: gray;
}
.none {
  display: none;
}
.block {
  display: block;
}

/* radios */
.control-group {
  margin-top: 5px;
  display: inline-block;
  vertical-align: top;
  text-align: left;
}
.control {
  display: inline-block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 5px;
  cursor: pointer;
  font-size: 18px;
  margin-right: 10px;
}
.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.control__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background: #e6e6e6;
}
.control--radio .control__indicator {
  border-radius: 50%;
}
.control:hover input ~ .control__indicator,
.control input:focus ~ .control__indicator {
  background: #ccc;
}
.control input:checked ~ .control__indicator {
  background: #4d5967;
}
.control:hover input:not([disabled]):checked ~ .control__indicator,
.control input:checked:focus ~ .control__indicator {
  background: #4d5967;
}
.control input:disabled ~ .control__indicator {
  background: #e6e6e6;
  opacity: 0.6;
  pointer-events: none;
}
.control__indicator:after {
  content: "";
  position: absolute;
  display: none;
}
.control input:checked ~ .control__indicator:after {
  display: block;
}
.control--checkbox .control__indicator:after {
  left: 8px;
  top: 4px;
  width: 3px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.control--checkbox input:disabled ~ .control__indicator:after {
  border-color: #7b7b7b;
}
.control--radio .control__indicator:after {
  left: 7px;
  top: 7px;
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background: #fff;
}
.control--radio input:disabled ~ .control__indicator:after {
  background: #7b7b7b;
}
.new-search-btn1 {
  background: #4d5967;
  color: #fff;
  border: none;
  transition: background-color 0.5s ease;
  cursor: pointer;
}
.new-search-btn1:hover {
  background: #373f49;
}
.new-search-btn2 {
  background: #6a7b8e;
  color: #fff;
  border: none;
  transition: background-color 0.5s ease;
  cursor: pointer;
}
.new-search-btn2:hover {
  background: #3e4b5a;
}
.dp-custom-input {
  padding: 10px 10px 10px 10px !important;
}
.clear-btn {
  position: absolute;
  right: 0;
  top: 14px;
  border: none;
  background: none;
}
.clear-hide {
  display: none !important;
}
.input-wrap {
  position: relative;
  display: block;
}

.dp__action_cancel {
  color: var(--dp-text-color);
  border: 1px solid var(--dp-border-color);
}

.dp__action_buttons .dp__action_select {
  background: var(--dp-primary-color);
  color: var(--dp-primary-text-color);
}

/* overlay */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.form-container {
  background: white;
  border-radius: 8px;
  padding: 30px;
  max-width: 800px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.section-header {
  
}

.section-container {
  margin-bottom: 10px;
  padding-left: 12px;
  position: relative; /* Containing block for absolute positioning */
  display: block;
  width: 100%; /* Full width of parent */
}

.section-title {
  font-size: 22px;
  font-weight: 300;
  margin: 0;
  color: #00bcbc;
  display: inline-block; /* Only takes content width */
  position: relative; /* For positioning the line */
  padding-right: 20px; /* Space between title and line */
  display: flex;
  align-items: center;
}

.section-title::after {
  content: '';
  position: absolute;
  top: 50%; /* Center vertically */
  transform: translateY(-50%); /* Adjust for vertical centering */
  left: 100%; /* Start at the right edge of the title */
  width: calc(100% - 20px); /* Extend to the right edge of the parent container */
  height: 1px; /* Thin line */
  background: linear-gradient(to right, #e1e1e1, #f5f5f5); /* Light gray gradient */
}

.section-title svg{
  width: 20px;
  margin-right: 5px;
}

.form-section {
  margin-bottom: 10px;
}

.required::before {
  content: "*\00A0"; /* Asterisk followed by non-breaking space */
  color: red;
  position: relative;
  display: inline-block;
}

.info-icon {
  color: #007bff;
  margin-left: 5px;
  cursor: pointer;
}

.checkbox-group {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  margin-top: 10px;
}

.checkbox-item {
  display: flex;
  align-items: center;
}

.checkbox-item input[type="checkbox"] {
  margin-right: 8px;
}

.btn-close {
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.btn-close:hover {
  color: #000;
}

.form-actions {
  margin-top: 30px;
  text-align: right;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  padding: 10px 30px;
  font-weight: 600;
}

.btn-secondary {
  padding: 10px 30px;
  font-weight: 600;
  margin-right: 10px;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.form-group label {
  color: #575757 !important;
  font-size: 13px !important;
  font-weight: 300 !important;
}
input.form-control {
  background: #f1f6f9 !important;
}
select.form-control {
  background: #f1f6f9 !important;
}
.form-group {
  margin-bottom: 10px;
}
.checkbox-item {
  position: relative;
}

.custom-checkbox {
  /* Hide default checkbox */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  position: relative;
  outline: none;
}

.custom-checkbox + label {
  cursor: pointer;
}

/* Custom checkbox unchecked state */
.custom-checkbox + label::before {
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #ced4da; /* Default border color */
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

/* Custom checkbox checked state */
.custom-checkbox:checked + label::before {
  background-color: #00bcbc !important; /* Your desired color */
  border-color: #00bcbc !important;
}

/* Optional: Add checkmark for checked state */
.custom-checkbox:checked + label::after {
  content: "\2713"; /* Unicode checkmark */
  color: white;
  font-size: 12px;
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
}
.admin-buttons {
  transition: transform 0.2s;
  transform: scale(1);
}
.admin-buttons:hover {
  transform: scale(1.05);
}
.tooltip-label {
  position: relative; /* Required for positioning the tooltip */
  cursor: pointer; /* Optional: Indicates interactivity */
}

/* Tooltip text */
.tooltip-label::after {
  content: attr(data-tooltip); /* Use data-tooltip attribute for content */
  position: absolute;
  top: -30px; /* Position above the label */
  left: 50%;
  transform: translateX(-50%); /* Center horizontally */
  background-color: #333; /* Dark background */
  color: #fff; /* White text */
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap; /* Prevent text wrapping */
  opacity: 0; /* Hidden by default */
  visibility: hidden; /* Hidden by default */
  transition: opacity 0.2s, visibility 0.2s; /* Smooth transition */
  z-index: 1100; /* Ensure it’s above other elements */
}

/* Show tooltip on hover */
.tooltip-label:hover::after {
  opacity: 1;
  visibility: visible;
}

/* Optional: Add a small arrow below the tooltip */
/*
.tooltip-label::before {
  content: '';
  position: absolute;
  top: -8px; 
  left: 50%;
  transform: translateX(-50%);
  border: 4px solid transparent;
  border-top-color: #333; 
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s, visibility 0.2s;
}

.tooltip-label:hover::before {
  opacity: 1;
  visibility: visible;
}
  */
</style>
<style>
#adminCompanies .vs__dropdown-menu {
  background: #f1f6f9 !important;
}
</style>
